import { Col, Form } from "react-bootstrap";
import Tooltip from "./Tooltip";
const InputCol = ({
  label,
  placeholder,
  name,
  value,
  errorMsg = "",
  handleChange,
  isValidate,
  validateInput,
  type = "number",
  colClass = "class-placeholder",
  isFullWidth = false,
  disabled = false,
  hint = "",
}) => {
  return (
    <Form.Group
      as={Col}
      sm={12}
      lg={isFullWidth ? 12 : 6}
      className={`mb-3 ${colClass}`}
    >
      <Form.Label htmlFor={label.toLowerCase()} className="d-flex ">
        <small>{label} </small>
        {hint && <Tooltip text={hint} />}
      </Form.Label>
      <Form.Control
        id={label.toLowerCase()}
        name={name}
        value={value}
        autoComplete="off"
        type={type}
        onChange={handleChange}
        // On focus change
        onBlur={e => {
          if (isValidate) validateInput(e);
        }}
        onWheel={e => {
          if (type === "number") e.target.blur();
        }}
        isInvalid={errorMsg ? true : false}
        aria-label={label.toLowerCase()}
        placeholder={placeholder}
        className="mt-auto"
        disabled={disabled}
      />
      <Form.Control.Feedback type="invalid">
        {errorMsg ? errorMsg : "The field cannot be empty."}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
export default InputCol;
